<template>
  <div v-if="!isEmbed">
    <i
      class="material-icons mic-icon"
      @click="startSpeechToText()"
      :class="isRecording ? 'mic-recording' : ''"
      >mic</i
    >
  </div>
</template>
<script>
export default {
  name: "SpeechInput",
  props: {
    field: Object,
  },
  data() {
    return {
      runtimeTranscription: "",
      isRecording: false,
    };
  },
  computed: {
    lang() {
      return "en_US";
    },
    isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
  },
  methods: {
    startSpeechToText() {
      this.isRecording = true;
      // initial of voice
      window.SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new window.SpeechRecognition();
      recognition.lang = this.lang;
      recognition.interimResults = true;

      // event current voice record word
      recognition.addEventListener("result", (event) => {
        var text = Array.from(event.results)
          .map((result) => result[0])
          .map((result) => result.transcript)
          .join("");
        this.runtimeTranscription = text;
        this.emitResult();
      });
      // end of transcription
      recognition.addEventListener("end", () => {
        this.emitResult();
        this.runtimeTranscription = "";
        recognition.stop();
        this.isRecording = false;
        this.submitTrackingClick(
          "Speech To Text",
          "Speech To Text",
          null,
          this.field ? { label: this.field.label } : null
        );
      });
      recognition.start();
    },
    emitResult() {
      this.$emit("input", this.runtimeTranscription);
    },
  },
};
</script>
<style scoped>
.mic-icon {
  cursor: pointer;
}

.mic-recording {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/common/speech/SpeechInput.vue